export const SHOW = '@@snackbar/SHOW'
export const DISMISS = '@@snackbar/DISMISS'
